import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// pt-BR
import ptBRCommon from './pt-BR/common.json';
import ptBRNavigation from './pt-BR/navigation.json';
import ptBRAuth from './pt-BR/auth.json';
import ptBRChat from './pt-BR/chat.json';
import ptBRDashboard from './pt-BR/dashboard.json';
import ptBRSettings from './pt-BR/settings.json';
import ptBRAutomation from './pt-BR/automation.json';
import ptBRMarketing from './pt-BR/marketing.json';
import ptBRNotifications from './pt-BR/notifications.json';

// en
import enCommon from './en/common.json';
import enNavigation from './en/navigation.json';
import enAuth from './en/auth.json';
import enChat from './en/chat.json';
import enDashboard from './en/dashboard.json';
import enSettings from './en/settings.json';
import enAutomation from './en/automation.json';
import enMarketing from './en/marketing.json';
import enNotifications from './en/notifications.json';

// Merge all namespaces into `common` so callers can use either pattern:
//   useTranslation('chat') + t('input.placeholder')   (namespace-scoped)
//   useTranslation()       + t('chat.input.placeholder')  (prefix in key, via defaultNS)
const buildCommon = (common, extras) => ({ ...common, ...extras });

const ptBRExtras = {
  navigation: ptBRNavigation,
  auth: ptBRAuth,
  chat: ptBRChat,
  dashboard: ptBRDashboard,
  settings: ptBRSettings,
  automation: ptBRAutomation,
  marketing: ptBRMarketing,
  notifications: ptBRNotifications,
};

const enExtras = {
  navigation: enNavigation,
  auth: enAuth,
  chat: enChat,
  dashboard: enDashboard,
  settings: enSettings,
  automation: enAutomation,
  marketing: enMarketing,
  notifications: enNotifications,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': {
        common: buildCommon(ptBRCommon, ptBRExtras),
        navigation: ptBRNavigation,
        auth: ptBRAuth,
        chat: ptBRChat,
        dashboard: ptBRDashboard,
        settings: ptBRSettings,
        automation: ptBRAutomation,
        marketing: ptBRMarketing,
        notifications: ptBRNotifications,
      },
      en: {
        common: buildCommon(enCommon, enExtras),
        navigation: enNavigation,
        auth: enAuth,
        chat: enChat,
        dashboard: enDashboard,
        settings: enSettings,
        automation: enAutomation,
        marketing: enMarketing,
        notifications: enNotifications,
      },
    },
    fallbackLng: 'pt-BR',
    defaultNS: 'common',
    ns: ['common', 'navigation', 'auth', 'chat', 'dashboard', 'settings', 'automation', 'marketing', 'notifications'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
